import '../styles/components/WhatsAppFAB.scss';

const WA_URL = 'https://wa.me/573005571857?text=Hola%2C%20quiero%20informaci%C3%B3n%20sobre%20productos%20promocionales';

const WhatsAppFAB = () => (
  <a
    href={WA_URL}
    className="WaFAB"
    target="_blank"
    rel="noreferrer"
    aria-label="Contactar por WhatsApp"
  >
    <svg className="WaFAB__icon" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 0C7.163 0 0 7.163 0 16c0 2.822.737 5.469 2.027 7.766L0 32l8.469-2.004A15.932 15.932 0 0 0 16 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.27 13.27 0 0 1-6.771-1.855l-.485-.289-5.029 1.189 1.213-4.899-.316-.503A13.27 13.27 0 0 1 2.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.27-9.878c-.398-.199-2.354-1.161-2.72-1.294-.365-.132-.631-.199-.897.2-.266.398-1.031 1.294-1.264 1.56-.232.266-.465.299-.863.1-.398-.2-1.681-.62-3.202-1.977-1.183-1.057-1.982-2.362-2.213-2.76-.232-.399-.025-.614.174-.813.179-.178.398-.465.597-.698.2-.232.266-.398.398-.664.133-.266.067-.498-.033-.697-.1-.199-.897-2.162-1.23-2.96-.323-.778-.651-.673-.897-.685l-.764-.013c-.266 0-.697.1-1.063.498-.365.398-1.395 1.362-1.395 3.325s1.429 3.856 1.628 4.122c.2.266 2.813 4.296 6.815 6.025.953.411 1.696.657 2.275.841.956.304 1.826.261 2.515.158.767-.114 2.354-.962 2.686-1.891.333-.93.333-1.727.233-1.892-.1-.165-.365-.264-.763-.463z"/>
    </svg>
    <span className="WaFAB__label">¿Hablamos?</span>
  </a>
);

export default WhatsAppFAB;
